@if (inputFieldConfig) {
<div [formGroup]="beneficiaryForm">
  <div class="pointer-events-none">
    <finxone-select-dropdown
      [options]="inputFieldConfig?.options ?? []"
      [formControlName]="formControlName"
      [optionLabelKey]="'label'"
      [optionValueKey]="'value'"
      [appendToBody]="true"
      [validationConfig]="validationConfig"
      [formControlInvalid]="
        !!(beneficiaryForm.get(formControlName)?.invalid && beneficiaryForm.get(formControlName)?.touched)
      "
      [selectedOption]="selectedOptionLabel"
      [label]="inputLabel"
      [placeholder]="inputFieldConfig?.inputPlaceholder ?? ''"
    ></finxone-select-dropdown>
  </div>
</div>
}
